import {Loader} from '@googlemaps/js-api-loader';

export default class ResidentialMarketMap {
  constructor(_container) {
    this._container = _container;
    this._markerData = JSON.parse(_container.dataset.markerData);
    this._apiKey = _container.dataset.apiKey;
    this._mapMarkerUri = _container.dataset.mapMarkerUri;
    this._createdMarkers = [];
    this._streetNames = [];

    this._initialize()
  }

  _initialize() {
    this._loader = new Loader({
      apiKey: this._apiKey,
      version: "weekly",
      libraries: ["places"]
    });
    this._createMap();
  }

  _createMap() {
    this._loader
      .load()
      .then((google) => {
        const mapOptions = {
          center: {lat: -34.397, lng: 150.644},
          zoom: 15,
          styles: this._getMapStyles()
        };
        this._map = new google.maps.Map(this._container, mapOptions);
        this._geocoder = new google.maps.Geocoder();
        this._addMarkersToMap();
      })
      .catch(e => {
        console.error('Error loading Google Map.',e)
      });


  }

  _addMarkersToMap() {
    let itemsProcessed = 0;
    let streetNameCount = {};

    // count how many items are located at tha same street address
    this._markerData.forEach(markerData => {
      if (markerData && markerData.street) {
        streetNameCount[markerData.street] = (streetNameCount[markerData.street] || 0) + 1;
      }
    });

    this._markerData.forEach((markerData, index) => {
      itemsProcessed++;
      if (markerData === null) {
        // Skip null marker data, depending on presence of relation to realEstateProperty
        // see: DistributionPackages/BgReussbuehl.ResidentialMarket/Resources/Private/Fusion/Component/Molecule/GoogleMap/GoogleMap.fusion
        return;
      }

      // Check if the street name has already been geocoded
      if (this._streetNames.includes(markerData.street) === false) {
        this._streetNames.push(markerData.street);
        const fullAddress = markerData.street + ', ' + markerData.zip + ' ' + markerData.city;
        this._geocoder.geocode({'address': fullAddress}, (results, status) => {
        }).then(results => {
          this._createMarker(results.results[0], markerData, streetNameCount[markerData.street]);
          if (itemsProcessed === this._markerData.length) {
            // All markers have been processed
            this._fitMapBoundsToMarkers();
          }
        });
      }
    });
  }

  _createMarker(place, markerData, numberOfItemsInSameStreet) {
    const marker = new google.maps.Marker({
      position: place.geometry.location,
      icon: {
        url: this._mapMarkerUri,
        scaledSize: new google.maps.Size(50, 50)
      }
    });
    const apartmentTitle = numberOfItemsInSameStreet > 1 ? numberOfItemsInSameStreet + ' Wohnungen' : markerData.title;
    const infoWindow = new google.maps.InfoWindow({
      content: '<div class="maps__infowindow">' + apartmentTitle + '<br />' + markerData.street + '</div>',
    });
    marker.addListener("click", () => {
      infoWindow.open({
        anchor: marker,
        map: this._map,
        shouldFocus: false,
      });
    });
    this._createdMarkers.push(marker);
    marker.setMap(this._map);
  }

  _fitMapBoundsToMarkers() {
    const bounds = new google.maps.LatLngBounds();
    this._createdMarkers.forEach(marker => {
      bounds.extend(marker.position);
    });
    this._map.fitBounds(bounds);
    // set fixed zoom if only 1 marker is present. Otherwise let decide google
    if(this._streetNames.length === 1) {
      this._map.setZoom(15);
    }
  }

  _getMapStyles() {
    // You can edit this JSON data at https://mapstyle.withgoogle.com/
    return [
      {
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#f5f5f5"
          }
        ]
      },
      {
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#efefef"
          }
        ]
      },
      {
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#f5f5f5"
          }
        ]
      },
      {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#bdbdbd"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#eeeeee"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#e5e5e5"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#c0d8ce"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#d0d3d0"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#dadada"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#d0d3d0"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      },
      {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#e5e5e5"
          }
        ]
      },
      {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#eeeeee"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#c9c9c9"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#cfdde2"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      }
    ];
  }

}
